module.exports = __webpack_public_path__ + "static/media/menu-accueil.89d9c1d5.svg";